import RacialTraitPane from './RacialTraitPane';

export default RacialTraitPane;
export { RacialTraitPane };
